import { Separator } from "@workspace/ui/components/separator"
import { useI18n } from "@/lib/i18n"
import { ImageSlot } from "./image-slot"

export function Philosophy() {
  const { t } = useI18n()

  return (
    <section
      id="studio"
      className="relative border-t border-border py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-14 xl:px-20">
        {/* Numbered heading */}
        <header className="flex items-center gap-5">
          <h2 className="flex items-baseline gap-3 text-2xl font-semibold tracking-[-0.02em] md:text-3xl">
            <span className="font-mono text-sm font-normal text-primary">03.</span>
            <span className="text-foreground">{t.studio.eyebrow}</span>
          </h2>
          <Separator className="h-px flex-1 bg-foreground/20" />
        </header>

        {/* Compact two-column: small square portrait + readable body copy */}
        <div className="mt-12 grid grid-cols-12 gap-x-4 gap-y-10 md:mt-16 md:gap-x-10">
          {/* Portrait — compact square */}
          <div className="col-span-12 md:col-span-4 lg:col-span-3">
            <ImageSlot
              ratio="1 / 1"
              tone="dark"
              caption={t.studio.credit}
            />
          </div>

          {/* Copy — editorial body, not display */}
          <div className="col-span-12 md:col-span-8 lg:col-span-8 lg:col-start-5">
            <div>
              <h3 className="font-mono text-[11px] uppercase tracking-[0.24em] text-primary">
                I · {t.studio.missionLabel}
              </h3>
              <p className="mt-3 max-w-2xl text-[17px] leading-[1.6] text-foreground md:text-lg">
                {t.studio.missionBody}
              </p>
            </div>

            <Separator className="my-8 bg-foreground/12" />

            <div>
              <h3 className="font-mono text-[11px] uppercase tracking-[0.24em] text-primary">
                II · {t.studio.visionLabel}
              </h3>
              <p className="mt-3 max-w-2xl text-[17px] leading-[1.6] text-foreground md:text-lg">
                {t.studio.visionBody}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
